import { usePresetDates as r } from "./index.es348.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import "react";
import { useAPIContext as e } from "./index.es46.js";
const x = () => {
  const { token: t, environment: o } = e();
  return r({ token: t, environment: o });
};
export {
  x as usePresetDatesPLMapbox
};
//# sourceMappingURL=index.es241.js.map
